export default {
  isConnected: (state) => () => {
    return state.isLogged
  },
  hasPermission: (state) => (findCredential) => {
    if (!state.isLogged) {
      return false
    }
    let userCredentials = state.credentials
    return userCredentials.filter((currentCredential) => currentCredential === findCredential).length > 0
  },
  hasOneOfPermissions: (state, getters) => (findCredentials) => {
    if (typeof findCredentials === 'string') {
      findCredentials = [findCredentials]
    }
    return findCredentials.filter(getters.hasPermission).length > 0
  }
}
